import store from "@/store";
import Role from "@/utils/role";

export default {
  path: "/learning",
  meta: {
    requiresAuth: true
  },
  component: () =>
    import(/* webpackChunkName: "user-layout" */ "@/layouts/UserLayout"),
  beforeEnter: (to, from, next) => {
    if (store.state.role === Role.STUDENT) {
      next({ path: "/student/courses" });
      return;
    }
    next();
  },
  children: [
    {
      name: "showmaintainer",
      path: "showmaintainer",
      component: () => import("@/components/Administrador/ShowMaintainer"),
      beforeEnter: (to, from, next) => {
        if (store.state.role === Role.ADMIN) {
          next();
          return;
        }
        next(from.path);
      }
    },
    {
      name: "teachers",
      path: "teachers",
      component: () => import("@/components/Teacher/ShowTeachers")
    },
    {
      name: "courses",
      path: "courses",
      component: () => import("@/views/Teacher/Courses"),
      beforeEnter: (to, from, next) => {
        if (store.state.role === Role.ADMIN) {
          next({ path: "/learning/admin/courses" });
          return;
        }
        next();
      }
    },
    {
      name: "AdminCourses",
      path: "admin/courses",
      component: () => import("@/components/Curso/ShowAllCursos"),
      beforeEnter: (to, from, next) => {
        if (store.state.role === Role.ADMIN) {
          next();
          return;
        }
        next({ path: "/student/courses" });
      }
    },
    {
      name: "TeacherModules",
      path: "modules",
      component: () => import("@/views/Teacher/Modules")
    },
    {
      name: "editCourse",
      path: "courses/:id",
      component: () => import("@/components/Curso/EditCurso")
    },
    {
      name: "minute",
      path: "minutes",
      component: () => import("@/views/Institution/minute")
    },
    {
      name: "CourseProgress",
      path: "progress",
      component: () => import("@/views/Institution/CourseProgress")
    },
    {
      name: "students",
      path: "students",
      component: () => import("@/views/Teacher/StudentsInstitution")
    },
    {
      name: "CourseStudents",
      path: "students/admin",
      component: () => import("@/views/Teacher/StudentsCourse")
    },
    {
      name: "qualifications",
      path: "qualifications",
      component: () =>
        import("@/views/Teacher/Qualification/QualificationInstitution"),
      beforeEnter: (to, from, next) => {
        if (store.state.role === Role.ADMIN) {
          next({ path: "/admin/courses" });
          return;
        }
        next();
      }
    },
    {
      name: "qualifications-module",
      path: "qualifications/modules",
      component: () =>
        import("@/views/Teacher/Qualification/QualificationModule"),
      // beforeEnter: (to, from, next) => {
      //   if (store.state.role === Role.ADMIN) {
      //     next({ path: "/admin/courses" });
      //     return;
      //   }
      //   next();
      // }
    },
    {
      name: "qualifications-course",
      path: "qualifications/modules/mod",
      component: () =>
        import("@/views/Teacher/Qualification/QualificationEvaluation"),
      beforeEnter: (to, from, next) => {
        if (store.state.role === Role.ADMIN) {
          next({ path: "/admin/courses" });
          return;
        }
        next();
      }
    },
    {
      name: "qualifications-students",
      path: "qualifications/modules/mod/students",
      component: () =>
        import("@/views/Teacher/Qualification/QualificationStudent"),
      beforeEnter: (to, from, next) => {
        if (store.state.role === Role.ADMIN) {
          next({ path: "/admin/courses" });
          return;
        }
        next();
      }
    },
    {
      name: "showallinformationsstudent",
      path: "qualifications/modules/mod/general",
      component: () =>
        import("@/views/Teacher/Qualification/ShowAllInformationsStudent"),
      // beforeEnter: (to, from, next) => {
      //   if (store.state.role === Role.ADMIN) {
      //     next({ path: "/admin/courses" });
      //     return;
      //   }
      //   next();
      // }
    },
    {
      name: "editLesson",
      path: "editLesson",
      component: () => import("@/components/Leccion/EditLeccion")
    },
    {
      name: "teacherAttendanceShowCourse",
      path: "attendance/showcourse",
      component: () => import("@/views/Teacher/Attendance/ShowCourse")
    },
    {
      name: "teacherShowAttendance",
      path: "attendance/showattendace",
      component: () => import("@/views/Teacher/Attendance/Attendance")
    },
    {
      name: "editModule",
      path: "modules/edit",
      component: () => import("@/views/Teacher/Module")
    },
    {
      name: "showModule",
      path: "modules/mod",
      component: () => import("@/components/Curso/ShowCurso")
    },
    {
      name: "TeacherLessonDetail",
      path: "modules/mod/activity",
      component: () => import("@/components/Leccion/ShowLeccion")
    },
    {
      name: "perfilTeacher",
      path: "perfiluser",
      component: () => import("@/components/Usuario/Perfil")
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/teacherRoutes.js